import { LoginPayload } from '.';
import { KwardaLoginError } from '../../../models/Global';
import { aFetch } from 'afetch';

const endPoints = {
	apiBase: '/api.php',
	ping: '/api.php?q',
};

export const login = async (data: LoginPayload) => {
	const payload = new FormData();

	payload.append('zaloguj', JSON.stringify(data));

	return aFetch<void | KwardaLoginError>(endPoints.apiBase, {
		fetchArgs: {
			method: 'POST',
			body: payload,
		},
	});
};

export const getHasTwoFactor = async () => {
	return aFetch<boolean>(endPoints.ping, {
		overrideHandlers: {
			'200': async () => ({ success: true, data: false }),
			'404': async () => ({ success: true, data: true }),
		},
	});
};
